import { Dataset, GridRow } from '../../types/types';

/** Keeps report-only detail rows available to print while hiding them from the grid. */
export const selectGridRows = (
  rows: GridRow[] | null | undefined,
  dataset: Dataset | null | undefined
): GridRow[] | null | undefined => {
  const allowedRowTypes = dataset?.gridRowTypes;
  if (!rows || !Array.isArray(allowedRowTypes) || allowedRowTypes.length === 0) {
    return rows;
  }

  const allowed = new Set(allowedRowTypes);
  return rows.filter((row) => allowed.has(String(row.rowType ?? '')));
};
